import { Button } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';

import FieldsSelect from '../common/FieldsSelect';
import { prepareDropdown } from '../../utils/common';
import { filterClauseExcludeFields } from '../../constants/metainf';
import { extractMetaFor, isNotEmptyValue } from '../../utils/filter';
import ValueSelectorContainer from './ValueSelectorContainer';

const StyledDiv = styled.div`
  padding-bottom: 5px;
  margin-top: 10px;

  .events-filter-options {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    margin: 0 12px 5px 0;
  }

  .events-filter-options-select {
    display: flex;
    width: 295px;
  }

  .events-filter-options-add-filter {
    width: 32px;
    text-align: center;
  }
`;

const EventFilters = ({
  visibility,
  clauses,
  metainf,
  onSelectFilterClauseField,
  onRemoveFilterClause,
  onAddFilterClause,
  onSelectFilterClauseOperator,
  onFilterClauseValueChange,
  zoneId,
  onOthersChange,
  othersFilter,
}) => {
  return clauses.map((clause, index) => (
    <StyledDiv
      className="events-filter-container"
      hidden={!visibility}
      key={clause.id}
      style={{ ...(index !== clauses.length - 1 && { borderBottom: '1px dashed lightgray' }) }}
    >
      <div className="events-filter-options">
        <div className="events-filter-options-select">
          <span style={{ marginRight: 5 }}>{`${index + 1}.`}</span>
          <FieldsSelect
            value={clause.field}
            fields={prepareDropdown(metainf, false, filterClauseExcludeFields)}
            onSelect={(field) => {
              onSelectFilterClauseField(clause.id, field, extractMetaFor(field, metainf).type);
              if (othersFilter === clause.id) {
                onOthersChange(null);
              }
            }}
            style={{ flex: '1', width: 'calc(100% - 22px)' }}
          />
        </div>
        <Button
          className="square-icon-button"
          onClick={() => onRemoveFilterClause(clause.id)}
          style={{ border: '1px solid transparent' }}
        >
          <DeleteOutlined />
        </Button>
        <div
          className="events-filter-options-add-filter"
          style={{ visibility: index === clauses.length - 1 ? 'visible' : 'hidden' }}
        >
          <Button style={{ marginLeft: 0 }} icon={<PlusOutlined />} onClick={onAddFilterClause} />
        </div>
      </div>
      <ValueSelectorContainer
        style={{ width: '100%', margin: '0 0 5px' }}
        operatorStyle={{ width: 100 }}
        operatorValueStyle={{ width: '100%', maxWidth: 'none' }}
        onSelectOperator={(value, resetValue) => {
          if (othersFilter === clause.id && resetValue) {
            onOthersChange(null);
          }

          onSelectFilterClauseOperator(clause.id, value, resetValue);
        }}
        onValueChange={(value) => {
          onFilterClauseValueChange(clause.id, value);
          const clauseHasValue = isNotEmptyValue(value);
          if (othersFilter === clause.id && !clauseHasValue) {
            onOthersChange(null);
          }
        }}
        render={!!clause.field}
        operator={clause.operator}
        value={isNotEmptyValue(clause.value) ? clause.value : undefined}
        meta={extractMetaFor(clause.field, metainf)}
        zoneId={zoneId}
      />
    </StyledDiv>
  ));
};

export default EventFilters;
